import { useMemo } from 'react'

import { useDebouncedValue } from '@/hooks/useDebouncedValue'
import { enhancedApi as subsidiariesApi } from '@/services/api/tenant/subsidiaries'
import { useTenantSearchFormContext } from './useTenantSearchFormContext'

export const useSearchTenantHierarchies = (page?: number, size?: number) => {
  const { values } = useTenantSearchFormContext()
  const { name, type } = useDebouncedValue(values, 100)
  const { data, isFetching, isUninitialized } = subsidiariesApi.endpoints.listTenantHierarchies.useQuery({
    filterBy: type || 'all',
    query: name.trim() || undefined,
    page,
    size,
  })

  const normalized = useMemo(() => {
    if (!data) return undefined
    if (Array.isArray(data)) return { items: data, total: data.length }
    return { items: data.items || [], total: data.total || 0 }
  }, [data])

  return { data: normalized, isFetching, isUninitialized }
}
